// Libraries
import React from 'react';

// Supermove
import {Styled} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {
  CommunicationKindModel,
  ProductUser,
  TextMessageTemplateModel,
  UserModel,
} from '@supermove/models';
import {colors} from '@supermove/styles';

// App
import Tabs from '@shared/design/components/Tabs';
import {CommunicationInboxConversationUrlFilterType} from 'modules/Communication/CommunicationInbox/types/CommunicationInboxUrlFilterType';
import CommunicationsWidgetFooterSendText from 'modules/Project/V2/Show/components/widgets/CommunicationsWidget/CommunicationsWidgetFooterSendText';

const Line = Styled.View`
  border-bottom-width: 1px;
  border-color: ${colors.gray.border};
`;

const FooterContainer = Styled.View`
  background-color: ${colors.white};
`;

const ActionsContainer = Styled.View`
  flex-direction: row;
`;

const tabs: Array<{label: string; key: CommunicationKindModel}> = [
  {label: 'SMS', key: 'SMS'},
  {label: 'Email', key: 'EMAIL'},
  {label: 'Call', key: 'CALL'},
];

const CommunicationInboxProjectConversationFooter = ({
  customer,
  viewer,
  refetch,
  projectId,
  textMessageTemplates,
  selectedTextMessageTemplate,
  urlFilters,
}: {
  customer: UserModel;
  viewer: UserModel;
  refetch: () => void;
  projectId: string;
  textMessageTemplates: TextMessageTemplateModel[];
  selectedTextMessageTemplate: TextMessageTemplateModel | undefined;
  urlFilters: CommunicationInboxConversationUrlFilterType;
}) => {
  const activeActionType = urlFilters.get('actionType') || 'SMS';

  return (
    <FooterContainer>
      <Line />
      <ActionsContainer>
        <Tabs
          tabs={tabs}
          handlePressTab={(tab) => urlFilters.handleUpdate({actionType: tab.key})}
          activeTabIndex={tabs.findIndex((tab) => tab.key === activeActionType)}
          TabComponent={Tabs.SecondaryTab}
          isEnclosed
          scrollViewStyle={{borderWidth: 0}}
          tabStyle={{borderRadius: 2}}
          style={{flex: 1}}
        />
      </ActionsContainer>
      <Line />
      <CommunicationsWidgetFooterSendText
        customer={customer}
        viewer={viewer}
        refetch={refetch}
        projectId={projectId}
        textMessageTemplates={textMessageTemplates}
        selectedTextMessageTemplate={selectedTextMessageTemplate}
      />
    </FooterContainer>
  );
};

CommunicationInboxProjectConversationFooter.fragment = gql`
  ${CommunicationsWidgetFooterSendText.fragment}
  ${ProductUser.isSalesActive.fragment}

  fragment CommunicationInboxProjectConversationFooter_User on User {
    id
    phoneNumber
    email
    ...CommunicationsWidgetFooterSendText_User
  }

  fragment CommunicationInboxProjectConversationFooter_TextMessageTemplate on TextMessageTemplate {
    id
    ...CommunicationsWidgetFooterSendText_TextMessageTemplate
  }

  fragment CommunicationInboxProjectConversationFooter_Viewer on User {
    id
    productUsers {
      id
      ...ProductUser_isSalesActive
    }
    ...CommunicationsWidgetFooterSendText_Viewer
  }
`;

export default CommunicationInboxProjectConversationFooter;
